// components/portal/SourceTrialNotice.tsx

'use client';

import React from 'react';
import { useNoticeAcknowledgement } from './useNoticeAcknowledgement';

import {
  TrialFeedbackLink,
  TrialNotice,
  TrialNoticeSignature,
} from '@/components/portal/TrialNotice';

/** Pill text in the left nav, and the name used in the notice. */
export const SOURCE_TRIAL_LABEL = 'Limited Trial';

export const SourceTrialWelcome = () => {
  const { ready, accepted, accept } = useNoticeAcknowledgement('source:pilot-v1');
  return ready && !accepted ? <SourceTrialNotice onClose={accept} /> : null;
};

export const SourceTrialNotice = ({ onClose }: { onClose: () => void }) => (
  <TrialNotice label={SOURCE_TRIAL_LABEL} onClose={onClose}>
    {/* The CEO's own words, in the same register as the Slides notice. Do not rewrite this into
        product microcopy: it is a personal note to the evaluator. */}
    <p>Welcome to the pilot of Source.</p>
    <p>
      Source is in beta, you will run into bugs. Don&apos;t hesitate to let us know at{' '}
      <TrialFeedbackLink subject="Source pilot feedback" />
    </p>
    <p>
      To run a successful pilot, please use the tool on real world use cases and report to us any
      feedback for improvement.
    </p>
    <p>Have fun!</p>
    <TrialNoticeSignature />
  </TrialNotice>
);

export default SourceTrialNotice;
